import { FC } from 'react';

import { useRouter } from 'expo-router';
import { Alert } from 'react-native';

import { useRumPageView } from 'hooks/rum/use-rum-page-view';
import useEffectOnce from 'hooks/use-effect-once';
import { getStaticPathname } from 'navigation/location/location';
import { CustomEventNames, EventTypes, logEvent } from 'state/amplitude';
import logger from 'utils/logger';
import { routes } from 'utils/routing';

const NotFound: FC = () => {
  useRumPageView('not-found', 'Not Found');
  const router = useRouter();

  useEffectOnce(() => {
    const pathname = getStaticPathname();
    logEvent(CustomEventNames.PAGE_NOT_FOUND, EventTypes.Other, {
      path: pathname,
    });
    logger.warn({ message: '404 - Not Found, redirecting to home', attemptedPathname: pathname });

    if (__DEV__) {
      Alert.alert('404 - Not Found', `Path: ${pathname}`);
    }

    router.replace(routes.base);
  });
  return null;
};

export default NotFound;
